import { takeEvery, put } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { redirectToLogin } from 'shared/helpers/authentication'

function* setTimeoutToDismiss () {
  yield delay(3000)
  yield put({ type: 'DISMISS_SNACKBAR' })
}

/*
  Action -> () | Action
  This is meant to handle every async_fetch_failed action incase of async fetch failure
  If the failure is of a nature that requires a redirect, then will be a procedure
  Otherwise, will pass action.nextActionType on as a new dispatch call for a reducer
  to respond to
*/
export default function* checkAsyncError () {
   yield takeEvery('UNAUTHORIZED', redirectToLogin)
   yield takeEvery('HIDE_MESSAGE', setTimeoutToDismiss)
}
